/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Card } from '@coursera/coursera-ui';
import { SvgLoaderSignal } from '@coursera/coursera-ui/svg';

export const CalendarLoader = () => {
  return (
    <Card style={{ width: '100%' }}>
      <div
        className="rc-CalendarLoader horizontal-box align-items-absolute-center p-b-2"
        css={css`
          height: 978px;
        `}
      >
        <SvgLoaderSignal />
      </div>
    </Card>
  );
};

export const MobileCalendarLoader = () => {
  return (
    <Card style={{ width: '100%', padding: '1.5rem' }}>
      <div
        className="rc-MobileCalendarLoader horizontal-box align-items-absolute-center p-b-2"
        css={css`
          height: 60vh;
        `}
      >
        <SvgLoaderSignal />
      </div>
    </Card>
  );
};
